import gql from 'graphql-tag';

export default gql`
  query ProxyclickCompanies {
    proxyclickCompanies {
      _id
      name
      logoOriginal
    }
  }
`;
